import { render, staticRenderFns } from "./BlockForgotPassword.vue?vue&type=template&id=1d6b5adb&scoped=true&"
import script from "./BlockForgotPassword.vue?vue&type=script&lang=js&"
export * from "./BlockForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./BlockForgotPassword.vue?vue&type=style&index=0&id=1d6b5adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b5adb",
  null
  
)

export default component.exports